<template>
  <div class="key-indicator">
    <MoreTitle title="主要指标" @click="goPage" />
    <div class="grid-layout edge-padding">
      <RowInfo label="市盈率">
        <template v-slot:label>
          <div class="syl">{{ $t('市盈率') }}<sup>TTM</sup></div>
        </template>
        {{ $digitjs(quoteExtendData.perTtm).rounded() }}
      </RowInfo>
      <RowInfo label="市净率">{{ $digitjs(quoteExtendData.pbr).rounded() }}</RowInfo>
      <RowInfo label="每股收益">{{ $digitjs(incomeData.basicEPS).rounded() }}</RowInfo>
      <RowInfo label="每股净资产">{{ $digitjs(quoteExtendData.nav).rounded() }}</RowInfo>
      <RowInfo label="营业总收入">{{ $digitjs(incomeData.operatingIncome).convert() }}</RowInfo>
      <RowInfo label="营收同比">{{ $digitjs(incomeData.operatingIncomeYoY).unit('%').rounded() }}</RowInfo>
      <RowInfo label="净利润">{{ $digitjs(incomeData.netProfit).convert() }}</RowInfo>
      <RowInfo label="净利润同比">{{ $digitjs(incomeData.netProfitYoY).unit('%').rounded() }}</RowInfo>
    </div>
  </div>
</template>

<script>
import RowInfo from '@/components/common/RowInfo.vue'
export default {
  components: { RowInfo },
  data() {
    return {
      incomeData: {},
      quoteExtendData: {}
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    }
  },
  created() {
    this.getIncomeData()
    this.getQuoteExtend()
  },
  methods: {
    goPage() {
      this.$router.push({
        path: '/f10/statements',
        query: {
          symbol: this.symbol,
          type: 'indicators'
        }
      })
    },
    async getIncomeData() {
      const res = await this.$post(this.$api.f10.hs + '/finance/income', {
        symbol: this.symbol,
        startDate: '1997-01-01'
      })
      const data =
        res.data?.filter((item) => {
          return [1, 6, 9, 12].includes(item.reportType)
        }) ?? []
      this.incomeData = data[0] ?? {}
    },
    async getQuoteExtend() {
      const res = await this.$post(this.$api.sdk.hs + '/stock/quote/extend', {
        symbols: [this.symbol],
        timeMode: 0
      })
      this.quoteExtendData = res.body?.[0] ?? {}
    }
  }
}
</script>

<style lang="scss" scoped>
.key-indicator {
  background: var(--bg-color-2);
}

.syl {
  transform: translateY(-4px);
}
</style>
